import React from 'react';

/**
 * ErrorBoundary — يلتقط أي خطأ غير متوقع في شجرة React ويعرض رسالة
 * بدل الشاشة البيضاء. مفيد لعزل النوافذ الكبيرة (Dialogs، Tabs).
 */
export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }
  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('ErrorBoundary caught:', error, info);
  }
  reset = () => this.setState({ hasError: false, error: null });
  render() {
    if (this.state.hasError) {
      return (
        <div className="p-4 bg-red-50 border border-red-200 rounded-lg text-right" dir="rtl">
          <div className="flex items-start gap-3">
            <div className="text-2xl">⚠️</div>
            <div className="flex-1">
              <h3 className="font-bold text-red-800 mb-1">حدث خطأ غير متوقع في هذه الواجهة</h3>
              <p className="text-sm text-red-700 mb-2">
                لا تقلق، بياناتك آمنة. حاول إغلاق هذه النافذة وإعادة فتحها، أو حدّث الصفحة (Ctrl+F5).
              </p>
              {this.state.error?.message && (
                <details className="text-xs text-red-600 mt-2">
                  <summary className="cursor-pointer">تفاصيل تقنية للمطوّر</summary>
                  <pre className="mt-1 p-2 bg-white border border-red-200 rounded text-[10px] overflow-auto max-h-32">
                    {String(this.state.error?.message || this.state.error)}
                  </pre>
                </details>
              )}
              <button
                onClick={this.reset}
                className="mt-3 px-3 py-1 bg-red-600 hover:bg-red-700 text-white text-sm rounded"
              >
                🔄 إعادة المحاولة
              </button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
